import AOS from 'aos';

$(function () {
    aos_init();
})

$(window).on('load', function () {
    aos_init();
});

function aos_init() {
    if ($('body').hasClass('single-realworks_wonen')) {
        return; // AOS bugt op de single page
    }

    AOS.init({
        once: true,
    });
}
